import type { ReactNode } from "react";
import { Check } from "lucide-react";
import { InstagramIcon, WhatsAppIcon } from "@/components/admin_dashboard/BrandIcons";
import { useLoopStep } from "./useLoopStep";
import "./how-mocks.css";

const sources: { name: string; icon: ReactNode; quote: string; fact: string }[] = [
  { name: "WhatsApp", icon: <WhatsAppIcon size={24} />, quote: "Evenings work best for me, after 6pm.", fact: "Prefers weekday evenings" },
  { name: "Acuity", icon: <img className="pm-logo pm-logo--app" src="/acuity-icon.ico" alt="" />, quote: "New booking: Fri 30 Oct, 4pm", fact: "Booked Fri 30 Oct, 4pm" },
  { name: "Tally", icon: <img className="pm-logo" src="/tally-icon.svg" alt="" />, quote: "Access needs: step-free entrance", fact: "Needs step-free access" },
  { name: "Instagram", icon: <InstagramIcon size={24} />, quote: "Is there parking nearby?", fact: "Asked about parking" },
];

const TICKS = 4;

/** Sources sit in a row on top; each lights up in turn, drops its message down, and adds a fact to the profile below. */
export default function ProfileMock() {
  const [ref, step] = useLoopStep(TICKS * sources.length + 4, 700);
  const active = Math.floor(step / TICKS);
  const showing = active < sources.length && step % TICKS < TICKS - 1;
  return (
    <div className="hm pm" ref={ref}>
      <div className="pm-sources">
        {sources.map((source, i) => (
          <div className={`pm-source${showing && active === i ? " is-active" : ""}${step >= TICKS * i + TICKS - 1 ? " is-done" : ""}`} key={source.name}>
            <span className="pm-source-icon">{source.icon}<Check className="pm-source-check" aria-hidden /></span>
            <small>{source.name}</small>
          </div>
        ))}
      </div>
      <div className="pm-quote">
        {showing && <p key={active}>“{sources[active].quote}”</p>}
      </div>
      <div className="pm-card">
        <div className="pm-card-head">
          <span className="lm-avatar">PY</span>
          <div><strong>Priscilla Yeo</strong><small>{step >= TICKS - 1 ? "Profile building" : "Waiting to learn"}</small></div>
        </div>
        <div className="pm-facts">
          {sources.map((source, i) => (
            <div className={`lm-fact${step >= TICKS * i + TICKS - 1 ? " is-on" : ""}`} key={source.fact}>
              <b>{source.fact}</b>
              <small>{source.name}</small>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
